// src/router/Router.tsx
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AccessDeniedPage from '../unauth-pages/auth/access/Access';
import ErrorPage from '../unauth-pages/auth/error/Error';
import LandingPage from '../unauth-pages/landing/LandingPage';
import NotFoundPage from '../unauth-pages/pages/notfound/NotFound';
import RedeemOffer from '../unauth-pages/landing/RedeemOffer';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/notfound" element={<NotFoundPage />} />
      <Route path="/auth/access" element={<AccessDeniedPage />} />
      <Route path="/auth/error" element={<ErrorPage />} />
      <Route path="/redeem/offer" element={<RedeemOffer />} />
    </Routes>
  );
};

export default AppRouter;
